import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconBodyType: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="body-type">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 19a3.001 3.001 0 0 1-2.94-2.4H9.94a3.001 3.001 0 0 1-5.909-.164l-.694-.347A2.6 2.6 0 0 1 1.9 13.764v-2.936c0-.69.274-1.35.761-1.838L5.49 6.162A2.6 2.6 0 0 1 7.328 5.4h4.911a2.6 2.6 0 0 1 1.728.657l3.653 3.247a1.4 1.4 0 0 0 .439.265l2.354.882a2.6 2.6 0 0 1 1.687 2.435V14a2.6 2.6 0 0 1-2.153 2.562A3 3 0 0 1 17 19ZM12.24 6.6a1.4 1.4 0 0 1 .93.354l3.653 3.247c.24.213.515.38.815.491l2.353.883a1.4 1.4 0 0 1 .909 1.311V14a1.4 1.4 0 0 1-.974 1.334 1.387 1.387 0 0 1-.24.054c-.18.011-.362.012-.544.012h-.445a1.8 1.8 0 1 1-3.395 0H8.697a1.8 1.8 0 1 1-3.395 0h-.661l-.767-.384a1.4 1.4 0 0 1-.774-1.252v-2.936a1.4 1.4 0 0 1 .41-.99L6.338 7.01a1.4 1.4 0 0 1 .986-.41H12.239Z"
    />
  </Icon>
);
